export const ERRORS_FOR_DESELECT_DISCOUNT = [
    "Ошибка при применении скидки",
    // COMPANY_INSUFFICIENT_BALANCE
    "Скидка для вашей компании временно неактивна",
    // PSY_IS_NOT_AVAILABLE_FOR_POST_PAID
    "Сейчас вы не можете записаться к этому психологу с применением корпоративной скидки, выберите другого специалиста",
    // COMPANY_LIMIT_FOR_FUTURE_BOOKINGS_EXCEEDED
    "У вас ограничено количество сессий, на которые можно записаться заранее по корпоративной скидке. Вы сможете записаться после того, как состоится ваша ближайшая сессия.",
]
